export default "/_next/static/chunks/fonts/Outfit Regular-e853df41b41bc9489a8bfae49e697115.ttf";